import { render, staticRenderFns } from "./Movimiento-entre-sucursales.vue?vue&type=template&id=182745db&scoped=true"
import script from "./Movimiento-entre-sucursales.vue?vue&type=script&lang=js"
export * from "./Movimiento-entre-sucursales.vue?vue&type=script&lang=js"
import style0 from "./Movimiento-entre-sucursales.vue?vue&type=style&index=0&id=182745db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182745db",
  null
  
)

export default component.exports